import { render, staticRenderFns } from "./GoodsGroup.vue?vue&type=template&id=7f0a7100&scoped=true"
import script from "./GoodsGroup.vue?vue&type=script&lang=js"
export * from "./GoodsGroup.vue?vue&type=script&lang=js"
import style0 from "./GoodsGroup.vue?vue&type=style&index=0&id=7f0a7100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a7100",
  null
  
)

export default component.exports